
export const loadJs = (url:any, callback:any) => {
  const node = document.createElement('script');
  node.setAttribute('src', url);
  document.body.appendChild(node);
  node.onload = () => callback && callback();
};
export const lazyMping = () =>
  new Promise<void>((resolve) => {
    if ((window as any).MPing) {
      resolve();
    } else {
      const url = '//wl.jd.com/unify.min.js';
      loadJs(url, () => {
        resolve();
      });
    }
  });
export const sendArticlePV = (articleInfo:any) => {
  try {
    lazyMping().then(() => {
      const pv = new (window as any).MPing.inputs.PV({
        page_id: `JDDoctor_${articleInfo.articleType}DetailsPage`,
      });
      pv.page_param = `{"ArticleID":${articleInfo.id}}`;
      // 构造上报实例
      const mping = new (window as any).MPing();
      mping.send(pv);
    });
  } catch (e) {
    console.log(e);
  }
};

export const sendArticleClick = (eventId:any, articleInfo:any, config?: any) => {
  try {
    lazyMping().then(() => {
      const click = new (window as any).MPing.inputs.Click(eventId);
      // 构造上报实例
      const mping = new (window as any).MPing();
      let jsonParam = config;
      if (config?.clickType) {
        const { clickType, ...otherConfig } = config;
        jsonParam = otherConfig;
      }
      const commonConfig = articleInfo.articleType === 'Article' ? { articleId: articleInfo.id } : { videoId: articleInfo.id };
      click.page_name = '文章详情页';
      click.page_no = articleInfo.articleType === 'Article' ? 12260 : 12261;
      click.page_id = `JDDoctor_${articleInfo.articleType}DetailsPage`;
      click.click_type = config?.clickType || '1';
      click.skuposition = config?.clickType === '0' ? '否' : '是';
      click.is_order = articleInfo.isOrder || '是';
      click.json_param = config ? JSON.stringify({ ...jsonParam, ...commonConfig }) : JSON.stringify(commonConfig);
      click.updateEventSeries();
      mping.send(click);
    });
  } catch (e) {
    console.log(e);
  }
};

/**
 * 点击埋点
 * eventId 事件id
 * page_name 页面名称
 * page_id 页面id
 * param json参数{“ServicePackID":"对应服务包ID"}
 * click_type 点击类型
 * is_order 计入订单
 * skuposition 加购sku位置
 */
export const sendBaikeClick = (eventId: string, articleInfo: any, urlFunction?: () => void) => {
  try {
    lazyMping().then(() => {
      const click = new (window as any).MPing.inputs.Click(eventId);
      // 构造上报实例
      const mping = new (window as any).MPing();
      click.page_name = articleInfo.pageName;
      click.page_no = articleInfo.pageNo;
      click.page_id =
      eventId || 'MHealthEncyclopedia_DiseaseDetails';
      click.json_param = JSON.stringify(articleInfo.jsonParam);
      click.click_type = articleInfo.clickType || 1;
      click.is_order = articleInfo.isOrder || '是';
      click.skuposition = '否';
      click.page_param = '';
      click.sku_id_position = articleInfo.skuidposition;
      click.updateEventSeries();
      mping.send(click);
      if (urlFunction) {
        setTimeout(urlFunction, 300);
      }
    });
  } catch (e) {
    console.log(e);
  }
};

export const sendBaikePV = (pageId: string, pageParam?: any,jsonParam?: any) => {
  try {
    lazyMping().then(() => {
      const pv = new (window as any).MPing.inputs.PV({
        page_id: pageId,
      });
      pv.event_id = pageId;
      pv.page_param = JSON.stringify(pageParam);
      pv.json_param = JSON.stringify(jsonParam);
      // 构造上报实例
      const mping = new (window as any).MPing();
      mping.send(pv);
    });
  } catch (e) {
    console.log(e);
  }
};

export const sendListPV = (pageId: string) => {
  try {
    lazyMping().then(() => {
      const pv = new (window as any).MPing.inputs.PV({
        page_id: pageId,
      });
      // 构造上报实例
      const mping = new (window as any).MPing();
      mping.send(pv);
    });
  } catch (e) {
    console.log(e);
  }
};
